module.exports = __webpack_public_path__ + "img/sv98.ea79357b.svg";